// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.intro[data-v-7bb8aada] {

    margin-left: auto;

    margin-right: auto;

    display: flex;

    max-width: 50rem;

    flex-direction: column;

    align-items: center;

    padding-top: 2.5rem;

    padding-bottom: 2.5rem;

    text-align: center;

    width: 100%;

    padding-right: 1rem;

    padding-left: 1rem;

    margin: auto
}
@media (min-width: 640px) {
.intro[data-v-7bb8aada] {

        padding-right: 1.5rem;

        padding-left: 1.5rem
}
}
@media (min-width: 1320px) {
.intro[data-v-7bb8aada] {

        max-width: 1320px
}
}
@media (min-width: 640px) {
.intro[data-v-7bb8aada] {

        padding-top: 5rem;

        padding-bottom: 5rem;

        width: calc((100vw - 1.5rem) / 8 * 6 + 1.5rem)
}
}
@media (min-width: 1320px) {
.intro[data-v-7bb8aada] {

        width: calc((1320px - 1.5rem) / 12 * 8 + 1.5rem)
}
}
.intro__logo[data-v-7bb8aada] {

    width: 3.5rem
}
.intro__title[data-v-7bb8aada] {

    margin-top: 1rem;

    font-family: Mont;

    line-height: 1.35;

    font-size: 1.5rem;

    font-weight: 700
}
@media (min-width: 996px) {
.intro__title[data-v-7bb8aada] {

        margin-top: 2rem;

        font-family: Mont;

        line-height: 1.35;

        font-size: 2rem;

        font-weight: 700
}
}
.intro__body[data-v-7bb8aada] {

    margin-top: 1rem;

    font-family: Roboto;

    line-height: 1.35;

    font-size: 1.125rem;

    font-weight: 400
}
.intro__highlighted[data-v-7bb8aada] {

    margin-top: 2.5rem;

    font-family: Roboto;

    line-height: 1.35;

    font-size: 1.125rem;

    font-weight: 700
}
.intro__remarked[data-v-7bb8aada] {

    display: block;

    --tw-text-opacity: 1;

    color: rgb(220 160 10 / var(--tw-text-opacity))
}
.intro__underline[data-v-7bb8aada] {

    margin-left: auto;

    margin-right: auto;

    margin-bottom: 1.5rem;

    display: block
}
@media (min-width: 996px) {
.intro__underline[data-v-7bb8aada] {

        margin-bottom: 0
}
}
`, "",{"version":3,"sources":["webpack://./resources/js/lego/partials/home/Intro.vue"],"names":[],"mappings":";AA4BA;;IAAA,iBAAA;;IAAA,kBAAA;;IAAA,aAAA;;IAAA,gBAAA;;IAAA,sBAAA;;IAAA,mBAAA;;IAAA,mBAAA;;IAAA,sBAAA;;IAAA,kBAAA;;IAAA,WAAA;;IAAA,mBAAA;;IAAA,kBAAA;;IAAA;AAAA;AAAA;AAAA;;QAAA,qBAAA;;QAAA;AAAA;AAAA;AAAA;AAAA;;QAAA;AAAA;AAAA;AAAA;AAAA;;QAAA,iBAAA;;QAAA,oBAAA;;QAAA;AAAA;AAAA;AAAA;AAAA;;QAAA;AAAA;AAAA;AAGA;;IAAA;AAAA;AAIA;;IAAA,gBAAA;;IAAA,iBAAA;;IAAA,iBAAA;;IAAA,iBAAA;;IAAA;AAAA;AAAA;AAAA;;QAAA,gBAAA;;QAAA,iBAAA;;QAAA,iBAAA;;QAAA,eAAA;;QAAA;AAAA;AAAA;AAIA;;IAAA,gBAAA;;IAAA,mBAAA;;IAAA,iBAAA;;IAAA,mBAAA;;IAAA;AAAA;AAIA;;IAAA,kBAAA;;IAAA,mBAAA;;IAAA,iBAAA;;IAAA,mBAAA;;IAAA;AAAA;AAIA;;IAAA,cAAA;;IAAA,oBAAA;;IAAA;AAAA;AAIA;;IAAA,iBAAA;;IAAA,kBAAA;;IAAA,qBAAA;;IAAA;AAAA;AAAA;AAAA;;QAAA;AAAA;AAAA","sourcesContent":["<template>\n  <section class=\"intro\">\n    <Logo icon class=\"intro__logo\" />\n    <h2 class=\"intro__title\">Hipotecarse es un viaje y queremos hacerlo contigo.</h2>\n    <p class=\"intro__body\">\n      Por eso, te acompañamos desde que empiezas a buscar tu hipoteca, hasta el día de la firma, pasando por la entrega de documentos y la\n      negociación para encontrar las mejores condiciones.\n    </p>\n    <p class=\"intro__highlighted\">\n      Y lo mejor de todo, es que no te costará nada\n      <span class=\"intro__remarked\">\n        porque nuestro servicio es gratuito.\n        <img class=\"intro__underline\" src=\"img/web/underline.svg\" alt=\"Icono subrayado\" />\n      </span>\n    </p>\n  </section>\n</template>\n\n<script>\nimport Logo from '@/lego/components/layout/Logo.vue';\n\nexport default {\n  components: { Logo },\n};\n</script>\n\n<style scoped lang=\"postcss\">\n.intro {\n  @apply container text-center py-sm sm:py-xxl sm:container-col-6 xl:container-col-8 flex flex-col items-center max-w-[50rem] mx-auto;\n\n  &__logo {\n    @apply w-lg;\n  }\n\n  &__title {\n    @apply style-subtitle-bold lg:style-title-sm-bold mt-xxxs lg:mt-xs;\n  }\n\n  &__body {\n    @apply mt-xxxs style-body;\n  }\n\n  &__highlighted {\n    @apply mt-sm style-body-bold;\n  }\n\n  &__remarked {\n    @apply block text-brand-primary-dark;\n  }\n\n  &__underline {\n    @apply block mx-auto mb-xxs lg:mb-0;\n  }\n}\n</style>\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
